import React, { useEffect, useRef, useState } from 'react';

import DoneIcon from '@material-ui/icons/Done';
import ExpandMore from '@material-ui/icons/ExpandMore';

import { useI18n } from 'Hooks';

import { Bar, Circle, Icon, List, ListItem, OuterWrapper, Text, Wrapper } from './styles';

export type ListItemType = {
  id: string;
  name: string;
  deleted?: boolean;
};

export interface Props {
  name?: string;
  selected?: string[];
  list?: ListItemType[];
  placeholder?: string;
  disableAddingMore?: boolean;
  handleChange: (list: string[]) => void;
}

const MultiSelect: React.FC<Props> = ({
  selected = [],
  list = [],
  placeholder,
  disableAddingMore = false,
  handleChange,
}) => {
  const { t } = useI18n();
  const ref = useRef<HTMLDivElement>(null);
  const [open, setOpen] = useState(false);
  const placeholderText = placeholder || t('General.Select');

  const onChange = (item: ListItemType) => {
    if (!selected) {
      handleChange([item.id]);
      return;
    }

    const found = selected?.find((listItem) => listItem == item.id);
    if (found) {
      handleChange(selected.filter((listItem) => listItem !== item.id));
    } else {
      handleChange([...selected, item.id]);
    }
  };

  const handleClick = () => {
    if (list.length > 0) {
      setOpen(!open);
    }
  };

  const handleDocClick = (e) => {
    if (ref.current && !ref.current.contains(e.target)) {
      setOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('click', handleDocClick);

    return () => {
      document.removeEventListener('click', handleDocClick);
    };
  }, []);

  let selectedText: string[] = [];

  if (selected && selected.length) {
    selectedText = selected.reduce((arr, sel) => {
      const found = list.find((listItem) => listItem.id == sel);
      if (found) {
        return [...arr, `${found.name} ${found.deleted ? `(${t('Dashboard.Deleted')})` : ''}`];
      }

      return arr;
    }, []);
  }

  return (
    <OuterWrapper ref={ref}>
      <Wrapper open={open}>
        <Bar onClick={handleClick}>
          <Text active={Boolean(selectedText.length)}>
            <span>{selectedText.length ? selectedText.join(', ') : placeholderText}</span>
          </Text>
          {list.length > 0 && (
            <Icon open={open}>
              <ExpandMore htmlColor="#8b8f93" />
            </Icon>
          )}
        </Bar>
        {open && (
          <List open={open}>
            {list.map((item, i) => (
              <ListItem
                key={i}
                onClick={() => onChange(item)}
                disabled={disableAddingMore && !selected.includes(item.id)}>
                <span>{item.name}</span>
                <Circle selected={selected.includes(item.id)}>
                  <DoneIcon htmlColor="#ffffff" />
                </Circle>
              </ListItem>
            ))}
          </List>
        )}
      </Wrapper>
    </OuterWrapper>
  );
};

export default MultiSelect;
